import { html, LitElement } from 'lit';
// eslint-disable-next-line import/no-extraneous-dependencies
import halkabox from 'halkabox';
import styles from './toujou-portfolio-gallery.css';

class ToujouPortfolioGallery extends LitElement {
  static get is() {
    return 'toujou-portfolio-gallery';
  }

  static get styles() {
    return styles;
  }

  static get properties() {
    return {
      _currentImageIndex: {
        type: Number,
      },
      _imageCount: {
        type: Number,
      },
    };
  }

  render() {
    return html`
      <slot id="slider" name="slider"></slot>
      <slot id="button" name="button" @click="${this._handleButtonClick}"></slot>
      <p class="pagination">
        <span class="pagination__current">${this._currentImageIndex}</span>
        <span class="pagination__separator">/</span>
        <span class="pagination__total">${this._imageCount}</span>
      </p>
    `;
  }

  constructor() {
    super();

    this._currentImageIndex = 1;
    this._imageCount = 0;

    this._mql = window.matchMedia('(max-width: 840px)');
    this._mql.addEventListener('change', () => {
      this._currentImageIndex = this._activeSlideIndex;
      this._imageCount = this._totalImageCount;
    });
  }

  /**
   * @returns {null|Element}
   * @private
   */
  get _sliderContent() {
    const sliderSlot = this.shadowRoot.querySelector('#slider');
    if (!sliderSlot) return null;

    const sliderElements = sliderSlot.assignedElements({ flatten: true });
    return sliderElements[0] || null;
  }

  /**
   * @returns {Element|null}
   * @private
   */
  get _firstSliderImage() {
    return this._sliderContent.querySelector('.slider__link') || null;
  }

  /**
   * @returns {number}
   * @private
   */
  get _totalImageCount() {
    return this._sliderContent.querySelectorAll('.glider-slide').length;
  }

  /**
   * Get the correct index of the currently active slide
   * We add 1 to the index to show it in a user-friendly way
   *
   * @returns {number}
   * @private
   */
  get _activeSlideIndex() {
    return +this._sliderContent.querySelector('.glider-slide.visible').getAttribute('data-gslide') + 1;
  }

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('glider-loaded', this._handleGliderLoaded);
    this.addEventListener('glider-slide-visible', this._handleGliderSlideVisible);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeEventListener('glider-loaded', this._handleGliderLoaded);
    this.removeEventListener('glider-slide-visible', this._handleGliderSlideVisible);
  }

  /**
   * Initialize halkabox when a child Glider first loads
   *
   * @private
   */
  _handleGliderLoaded() {
    const portfolioGallerySlider = this._sliderContent.querySelector('.slider');
    if (!portfolioGallerySlider) {
      console.error('TOUJOU: Could not get the portfolio gallery slider element');
      return;
    }

    this._imageCount = this._totalImageCount;
    halkabox.run(portfolioGallerySlider.getAttribute('data-lightbox'));
  }

  /**
   * Update the current image index whenever a new glider slide is visible
   *
   * @param event
   * @private
   */
  _handleGliderSlideVisible(event) {
    this._currentImageIndex = event.detail.slide + 1;
  }

  /**
   * When the button is clicked we need to open the lightbox showing the currently active slide
   *
   * @private
   */
  _handleButtonClick() {
    const currentVisibleImageLink = this._sliderContent.querySelector('.glider-slide.visible .slider__link');
    currentVisibleImageLink
      ? currentVisibleImageLink.click()
      : this._firstSliderImage.click();
  }
}

customElements.define(ToujouPortfolioGallery.is, ToujouPortfolioGallery);
